import React, {useEffect, useRef }  from 'react'
import Typical from "react-typical";
import MyVideo from "../img/Video.mp4"
import MainImage from "../img/MainImage.png"
import {Link, NavLink} from 'react-router-dom'
import './Home.scss'
import Loader from 'react-loaders'

function Home() {
    const videoEl = useRef(null);

    const attemptPlay = () => {
      videoEl &&
        videoEl.current &&
        videoEl.current.play().catch(error => {
          console.error("Error attempting to play", error);
        });
    };
  
    useEffect(() => {
      attemptPlay();
    }, []);
  return (
    <>
    <div className='container homepage flex'>
        <div className='text-zone flex-1 '>
        <Typical  steps={["Hello World", 300, 'Hey! I am',2000]} className='text-[#e5ebff] font-bold sm:text-lg md:text-4xl heading'/> <  Typical  loop={Infinity} steps={["Prarthna Luthra", 2000, 'a MERN Stack Developer',2000]} className='text-[#63e8ff] font-bold text-2xl md:text-5xl'  />
               
            <div className=' my-10'>

                   <div className="text-[#a4a9b9] font-[100] para text-sm
               md:text-lg w-[40vw] about">
                   I am a quick learner and enjoy learning languages and frameworks like React!. I have developed various MERN stack projects as well, you can check out my repositories for more details.
                   </div>
              
            </div>
            <Link to="/contact" class="relative p-0.5 inline-flex items-center justify-center font-bold overflow-hidden group rounded-md">
<span class="w-full h-full bg-gradient-to-br from-[#61d8fc] via-[#960bcd] to-[#ff00c6] group-hover:from-[#ff00c6] group-hover:via-[#960bcd] group-hover:to-[#04b8c5] absolute"></span>
<span class="relative px-6 py-1 transition-all ease-out bg-gray-900 rounded-md group-hover:bg-opacity-0 duration-400">
<span class="relative text-white">Contact Me</span>
</span>
</Link>

        </div>

        
        <div className='flex-grow '>
            
        <div className='relative'>
            {/* <img src={MainImage} className='w-[35vw]' /> */}
        {/* <img src={code} className='h-[10vh] top-[-14%] left-[-20%] absolute p-0'/> */}
        <video id="bg-video"
 
          style={{ 
            maxWidth: "80%", width: "35vw" , position:'absolute', top:0, bottom:0 }}
          // playsInline
          // loop
          muted
          disableBackgroundCover={ false}
         
          
          
          controls={false}
          alt="All the devices"
          src={MyVideo}
          ref={videoEl}
        />
      
 </div>
 

    </div>
    </div>

    <Loader type='ball-scale-multiple'/>
     </>


  )
}

export default Home